<template>
  <div class="pb-[10] bg-[#F7F7F9] h-[100vh]">
    <dg-head>
      <div class="flex items-center">
        <p class="cursor-pointer  pr-[40]" @click="push({ path: '/login' })"> <i class="icon">&#xe677;</i> 登录</p>
        <a :href="ENV.official" target="_blank"> <el-button size="mini" type="primary">返回首页</el-button></a>
      </div>
    </dg-head>
    <div class="forgetBox min-h-[84vh] pt-[84] md:pt-[50] md:min-h-[80vh] overflow-hidden">
      <div class="bg-[#fff] px-[44] pt-[38] pb-[28] w-[468] mx-[auto] rounded-[6] overflow-hidden">
        <p class="text-center font-500 t-[22] pb-[26] t-[#192530]">忘记密码</p>
        <div class="pb-[5]" v-if="tips.msg">
          <el-alert @close="() => { tips.msg = ''; tips.type = 'error'; }" v-show="tips.msg" :title="tips.msg"
            :type="tips.type" show-icon>
          </el-alert>
        </div>
        <el-form :model="formData" ref="formDataRef" label-width="1px" v-loading="forgetPaswLoading">
          <template v-if="editMobileType == 0">
            <div class="pb-[24]" v-loading="qrcodeLoading">
              <div class="text-center">
                <p class="t-[12] t-[#909399]">请使用微信扫码下方二维码进行验证</p>
                <div class="h-[150] w-[150] relative mt-[20]  mx-[auto]" @click="getCode" v-if="qrcode">
                  <div class="h-[150] w-[150] absolute top-[0] left-[0] flex items-center justify-center"
                    style="background-color: rgba(255, 255, 255, 0.9);" v-if="codeStatus == 2">
                    <div class="text-center">
                      <i class="icon t-[24] t-[#231815]">&#xe6f4;</i>
                      <p class="t-[12] t-[#000000]">二维码失效，点击刷新</p>
                    </div>
                  </div>
                  <img class="h-[150] w-[150]" :src="qrcode" alt="">
                </div>

                <div class="h-[150] w-[150] relative flex items-center justify-center mt-[20] mx-[auto]"
                  @click="getCode" v-else>
                  <div class="w-[138] text-center">
                    <img class="w-[138]" :src="getCityAssetsFile('loading_wx_code.png')" alt="">
                    <p class="t-[#999999] leading-[20]">加载中...</p>
                  </div>
                </div>

                <div class="mt-[18] flex items-center justify-center"><i
                    class="icon t-[#28C445] t-[18] mr-[4]">&#xe616;</i>
                  <span class="t-[14] t-[#303133]" v-if="codeStatus != 2 && codeStatus != ''">{{ codeStatus == 1 ?
                    "验证成功" : "请使用微信扫一扫" }}</span>
                  <span class="t-[14] t-[#303133]" v-else>请使用微信扫一扫</span>
                  <span class="t-[#3F80F5] t-[14] ml-[4] cursor-pointer" @click="getCode">刷新</span>
                </div>
              </div>
            </div>
            <el-form-item class="!mb-[0]" label="" prop="mobile" :rules="[
              { required: true, message: '请扫码校验' },
              { pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '请扫码校验' },
            ]">
              <el-input disabled size="large" class="large_input" v-model="formData.mobile" maxlength="11"
                placeholder="扫码自动填入手机号"></el-input>
            </el-form-item>
          </template>
          <div v-else>
            <el-form-item label="" prop="mobile" :rules="[
              { required: true, message: '请填写手机号' },
              { pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '请填写手机号' }
            ]">
              <el-input size="large" class="large_input" placeholder="*请输入手机号" maxlength="11" v-model="formData.mobile">
              </el-input>
            </el-form-item>
            <el-form-item label="" class="mb-[20]" prop="catchcode" :rules="[{ required: true, message: '请输入验证码' }]">
              <div class="flex">
                <div class="relative flex-1 pr-[10]">
                  <el-input size="large" class="large_input" placeholder="请输入验证码" v-model="formData.catchcode">
                  </el-input>
                </div>
                <div class="verificationCode w-[130] " @click="getcaptcha">
                  <img :src="verificationCode" alt="" class="w-[100%] h-[47]" />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="" prop="messagecode" :rules="[{ required: true, message: '请输入短信码' }]" class="mb-[20]">
              <div class="flex">
                <div class="relative flex-1 messagecode">
                  <el-input size="large" class="large_input" placeholder="请输入短信验证码" v-model="formData.messagecode">
                    <template v-slot:suffix>
                      <div
                        class="suffix cursor-pointer border-l-[1] border-[#d5dae5] border-solid w-[100] leading-[31] my-[9] t-[theme]"
                        @click="handleSend">{{ CountDownStatus ? "发送短信" :
                          `${CountDownNum}/s` }}</div>
                    </template>
                  </el-input>
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="pt-[16]">
            <el-button class="w-[100%]" type="primary" @click="handlerVerification('formDataRef')">下一步</el-button>
            <div v-if="support">
              <div class="flex items-center mt-[24]">
                <div class="flex-1 h-[1] bg-[#DFE2E9]"></div>
                <p class="mx-[10] t-[#C0C4CC] t-[14]">其它验证方式</p>
                <div class="flex-1 h-[1] bg-[#DFE2E9]"></div>
              </div>
              <div class="text-center mt-[20]">
                <template v-if="editMobileType == 1">
                  <div
                    class="w-[50] h-[50] bg-[#F0F7FF] rounded-[25] flex items-center justify-center mx-[auto] cursor-pointer"
                    @click="changeEditMobileType(0)">
                    <img class="w-[50] h-[50]" src="@/assets/img/wei_xin-logo.png" alt="">
                  </div>
                  <p class="t-[14] t-[#606266] mt-[11]">微信扫码</p>
                </template>
                <template v-else>
                  <div class="w-[50] h-[50] bg-[#F0F7FF] rounded-[25] flex items-center justify-center mx-[auto]"
                    @click="changeEditMobileType(1)">
                    <i class="icon t-[theme] t-[24]">&#xe754;</i>
                  </div>
                  <p class="t-[14] t-[#606266] mt-[11]">短信验证</p>
                </template>

              </div>
            </div>
          </div>

        </el-form>

      </div>
    </div>
    <div class="absolute bottom-[0] w-[100%] pb-[32] left-[0]">
      <dg-copyright></dg-copyright>
    </div>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import CountDown from "@/assets/js/countDown";
export default {
  mixins: [mixin],
  data() {
    return {
      // -------------------------------------------------------------------------------------------------------------------
      forgetPaswLoading: false,
      qrcodeLoading: false,
      qrcode: "",
      editMobileType: 1,//修改手机号方式
      modifyOper: false,//是否编辑
      authCode: "",
      timer: null,
      message: "",
      user: {},
      codeStatus: "",
      support: false,
      // -------------------------------------------------------------------------------------------------------------------

      tips: {
        msg: '',
        type: 'error'
      },
      CountDownNum: 60,
      CountDownStatus: true,
      verificationCode: "",
      formData: {
        loginName: "", // 账户名 17750877007
        password: "", // 123456  密码，cookie值加上当前日期做密钥（JSESSIONID-yyyy-MM-dd），对明文进行des加密
        catchcode: "", // 图形验证码
        messagecode: "", // 短信验证码
        mobile: "" // 手机号
      },
      countDown: {}
    };
  },
  methods: {
    getShowWeiXinQrcode() {
      this.forgetPaswLoading = true
      ajax.post({
        // headers:{'Content-Type': 'application/json'},
        url: '/customer/common/supportWxappletMobileAuthQrcode',
        data: {},
        success: (res) => {
          this.forgetPaswLoading = false
          // console.log(res, 'res')
          this.support = res.support
          if (res.support) {
            this.editMobileType = 0
            this.getCode();
          } else {
            this.formData.messagecode = ""
            clearInterval(this.timer)
            this.timer = null
            this.editMobileType = 1
          }
        },
        fail: () => {
          this.forgetPaswLoading = false
        },
      })
    },
    closeDialog2() {
      clearInterval(this.timer)
      this.timer = null
    },
    getCode() {
      this.qrcodeLoading = true
      this.codeStatus = ""
      clearInterval(this.timer)
      this.timer = null
      ajax.post({
        // headers:{'Content-Type': 'application/json'},
        url: '/customer/common/createWxappletMobileAuthQrcode',
        data: {},
        success: (res) => {
          this.qrcodeLoading = false
          this.qrcode = res.qrcode
          this.authcode = res.authcode || ""
          this.formData.messagecode = this.authcode
          this.timer = setInterval(() => {
            this.getStatus()
          }, 3000);
          // console.log(res, 'res')
        },
        fail: () => {
          this.qrcodeLoading = false
        },
      })
    },
    getStatus() {
      ajax.post({
        // headers:{'Content-Type': 'application/json'},
        url: '/customer/common/queryWxappletMobileAuthResult',
        data: {
          authCode: this.authcode
        },
        success: (res) => {
          // console.log(res, 'res')
          this.codeStatus = res.result
          if (res.result == 1) {
            clearInterval(this.timer)
            this.timer = null
            this.message = "验证成功"
            this.formData.mobile = res.mobile
          }
          if (res.result == 2) {
            clearInterval(this.timer)
            this.timer = null
            this.message = "二维码已过期，点击重新获取"

          }
        },
      })
    },
    // 切换修改方式
    changeEditMobileType(type) {
      this.$refs.formDataRef.clearValidate()
      this.editMobileType = type
      if (type == 1) {
        this.formData.messagecode = ""
        clearInterval(this.timer)
        this.timer = null
      } else {
        this.getCode()
      }
    },
    // 是否编辑
    handleModifyOper() {
      this.dialog2 = true
      this.getShowWeiXinQrcode()

    },


    /**
     * @author 伟健 / 张
     * @name 登录
     */
    async handlerVerification(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          ajax.post({
            url: "/customer/auth/checkSmsCode",
            data:
            // http://api.jfyancheng.com:8080/doc.html#/default/%E5%AE%98%E7%BD%91%E5%89%8D%E5%8F%B0-%E8%AE%A4%E8%AF%81%E6%A8%A1%E5%9D%97/checkSmsCodeUsingPOST
            {
              catchcode: this.formData.messagecode,  // 短信验证码 
              mobile: this.formData.mobile,  // 手机号 
            },
            self: this,
            success: res => {
              if (res) {
                this.$router.push({ path: '/modifyPasw' })
                sessionStorage.setItem('modifyPaswLast_phone', this.formData.mobile)
              }
            },
            fail: (err) => {
              this.tips.msg = err.msg;
              this.tips.type = 'error';
              this.getcaptcha()
            }
          });
        }
      });
    },

    /**
     * @author 伟健 / 张
     * @name 发送短信
     */
    handleSend() {
      if (!this.countDown.checkStatus()) {
        return;
      }
      let error = true
      this.$refs.formDataRef.validateField(['mobile', 'catchcode'], (errorMessage) => {
        if (errorMessage) {
          error = false // 校验失败时的提示信息
        }
      });
      if (error) {
        ajax.post({
          url: "/customer/common/sendSmsCode",
          data: {
            catchcode: this.formData.catchcode, // 图形验证码
            mobile: this.formData.mobile // 手机号码
          },
          self: this,
          success: res => {
            if (res) {
              this.countDown.start();
            }
          },
          fail: (err) => {
            this.tips.msg = err.msg;
            this.tips.type = 'error';
            this.getcaptcha();
          }
        });
      }




    },
    /**
     * @author 伟健 / 张
     * @name 获取图像码
     */
    getcaptcha() {
      ajax.post({
        url: "/customer/common/getcaptcha",
        data: {},
        self: this,
        success: res => {
          if (res) {
            this.verificationCode = res;
          }
        },
        fail: (err) => {
          this.tips.msg = err.msg;
          this.tips.type = 'error';
        }
      });
    },


  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },
  mounted() {
    this.countDown = new CountDown({
      self: this,
      /*   这两参数必填
       "CountDownNum": 30,
       "CountDownStatus": true,
       */
      id: "forgetPasw"
    });
  },
  created() {
    this.getcaptcha();
    this.getShowWeiXinQrcode()
  }
};
</script>

<style scoped lang="less">
// @import '~@/assets/css/var.less';

.shadow {
  box-shadow: 0 2px 10px 0 rgba(45, 72, 97, .1);
}

@media screen and (max-width: 1440px) {
  .forgetBox {
    padding-top: 0px !important;
    transform: scale(0.8);
  }
}

@media screen and (max-width: 1550px) {
  .forgetBox {
    padding-top: 0px !important;
    transform: scale(0.8);
  }
}

</style>
